var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Navbar'),_c('Banner'),_c('ProfiteerSection'),_c('Bedankt'),_c('MeerDanSection'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }